import React, { FC, createContext, useReducer, useEffect } from 'react';

import { reducer, initialState, ReducerType, StateType } from './Reducer';

const Store = createContext<ReducerType>([initialState, () => null]);

export const useStore = () => React.useContext(Store);

export const StoreProvider: FC<{
  state?: StateType;
}> = ({ children, state = initialState }) => {
  const storeReducer = useReducer(reducer, state);

  useEffect(() => {
    return () => {
      // dispatch reducer reset on unmount of provider
      storeReducer[1]({
        type: 'reattribution.reset',
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <Store.Provider value={storeReducer}>{children}</Store.Provider>;
};
